/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './pre-op-anaesthesia-chart.reducer';

export const PreOpAnaesthesiaChartDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const preOpAnaesthesiaChartEntity = useAppSelector(state => state.preOpAnaesthesiaChart.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="preOpAnaesthesiaChartDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.preOpAnaesthesiaChart.detail.title">PreOpAnaesthesiaChart</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.preOpAnaesthesiaChart.id">Id</Translate>
            </span>
          </dt>
          <dd>{preOpAnaesthesiaChartEntity.id}</dd>
          <dt>
            <span id="typeOfAnaesthesia">
              <Translate contentKey="tinyMedicRestApp.preOpAnaesthesiaChart.typeOfAnaesthesia">Type Of Anaesthesia</Translate>
            </span>
          </dt>
          <dd>{preOpAnaesthesiaChartEntity.typeOfAnaesthesia}</dd>
          <dt>
            <span id="generalCondition">
              <Translate contentKey="tinyMedicRestApp.preOpAnaesthesiaChart.generalCondition">General Condition</Translate>
            </span>
          </dt>
          <dd>{preOpAnaesthesiaChartEntity.generalCondition}</dd>
          <dt>
            <span id="ivAccess">
              <Translate contentKey="tinyMedicRestApp.preOpAnaesthesiaChart.ivAccess">Iv Access</Translate>
            </span>
          </dt>
          <dd>{preOpAnaesthesiaChartEntity.ivAccess}</dd>
          <dt>
            <span id="site">
              <Translate contentKey="tinyMedicRestApp.preOpAnaesthesiaChart.site">Site</Translate>
            </span>
          </dt>
          <dd>{preOpAnaesthesiaChartEntity.site}</dd>
          <dt>
            <span id="cannulaGuage">
              <Translate contentKey="tinyMedicRestApp.preOpAnaesthesiaChart.cannulaGuage">Cannula Guage</Translate>
            </span>
          </dt>
          <dd>{preOpAnaesthesiaChartEntity.cannulaGuage}</dd>
          <dt>
            <span id="raTechnique">
              <Translate contentKey="tinyMedicRestApp.preOpAnaesthesiaChart.raTechnique">Ra Technique</Translate>
            </span>
          </dt>
          <dd>{preOpAnaesthesiaChartEntity.raTechnique}</dd>
          <dt>
            <span id="raApproach">
              <Translate contentKey="tinyMedicRestApp.preOpAnaesthesiaChart.raApproach">Ra Approach</Translate>
            </span>
          </dt>
          <dd>{preOpAnaesthesiaChartEntity.raApproach}</dd>
          <dt>
            <span id="raNeedle">
              <Translate contentKey="tinyMedicRestApp.preOpAnaesthesiaChart.raNeedle">Ra Needle</Translate>
            </span>
          </dt>
          <dd>{preOpAnaesthesiaChartEntity.raNeedle}</dd>
          <dt>
            <span id="raSpace">
              <Translate contentKey="tinyMedicRestApp.preOpAnaesthesiaChart.raSpace">Ra Space</Translate>
            </span>
          </dt>
          <dd>{preOpAnaesthesiaChartEntity.raSpace}</dd>
          <dt>
            <span id="raDrug">
              <Translate contentKey="tinyMedicRestApp.preOpAnaesthesiaChart.raDrug">Ra Drug</Translate>
            </span>
          </dt>
          <dd>{preOpAnaesthesiaChartEntity.raDrug}</dd>
          <dt>
            <span id="raOnsetAction">
              <Translate contentKey="tinyMedicRestApp.preOpAnaesthesiaChart.raOnsetAction">Ra Onset Action</Translate>
            </span>
          </dt>
          <dd>{preOpAnaesthesiaChartEntity.raOnsetAction}</dd>
          <dt>
            <span id="raSensoryLevel">
              <Translate contentKey="tinyMedicRestApp.preOpAnaesthesiaChart.raSensoryLevel">Ra Sensory Level</Translate>
            </span>
          </dt>
          <dd>{preOpAnaesthesiaChartEntity.raSensoryLevel}</dd>
          <dt>
            <span id="raMotorLevel">
              <Translate contentKey="tinyMedicRestApp.preOpAnaesthesiaChart.raMotorLevel">Ra Motor Level</Translate>
            </span>
          </dt>
          <dd>{preOpAnaesthesiaChartEntity.raMotorLevel}</dd>
          <dt>
            <span id="gaPreOxygenation">
              <Translate contentKey="tinyMedicRestApp.preOpAnaesthesiaChart.gaPreOxygenation">Ga Pre Oxygenation</Translate>
            </span>
          </dt>
          <dd>{preOpAnaesthesiaChartEntity.gaPreOxygenation}</dd>
          <dt>
            <span id="induction">
              <Translate contentKey="tinyMedicRestApp.preOpAnaesthesiaChart.induction">Induction</Translate>
            </span>
          </dt>
          <dd>{preOpAnaesthesiaChartEntity.induction}</dd>
          <dt>
            <span id="inhalational">
              <Translate contentKey="tinyMedicRestApp.preOpAnaesthesiaChart.inhalational">Inhalational</Translate>
            </span>
          </dt>
          <dd>{preOpAnaesthesiaChartEntity.inhalational}</dd>
          <dt>
            <span id="etube">
              <Translate contentKey="tinyMedicRestApp.preOpAnaesthesiaChart.etube">Etube</Translate>
            </span>
          </dt>
          <dd>{preOpAnaesthesiaChartEntity.etube}</dd>
          <dt>
            <span id="etSize">
              <Translate contentKey="tinyMedicRestApp.preOpAnaesthesiaChart.etSize">Et Size</Translate>
            </span>
          </dt>
          <dd>{preOpAnaesthesiaChartEntity.etSize}</dd>
          <dt>
            <span id="etCuff">
              <Translate contentKey="tinyMedicRestApp.preOpAnaesthesiaChart.etCuff">Et Cuff</Translate>
            </span>
          </dt>
          <dd>{preOpAnaesthesiaChartEntity.etCuff}</dd>
          <dt>
            <span id="etOtherInfo">
              <Translate contentKey="tinyMedicRestApp.preOpAnaesthesiaChart.etOtherInfo">Et Other Info</Translate>
            </span>
          </dt>
          <dd>{preOpAnaesthesiaChartEntity.etOtherInfo}</dd>
          <dt>
            <span id="ventilation">
              <Translate contentKey="tinyMedicRestApp.preOpAnaesthesiaChart.ventilation">Ventilation</Translate>
            </span>
          </dt>
          <dd>{preOpAnaesthesiaChartEntity.ventilation}</dd>
          <dt>
            <span id="spontaneous">
              <Translate contentKey="tinyMedicRestApp.preOpAnaesthesiaChart.spontaneous">Spontaneous</Translate>
            </span>
          </dt>
          <dd>{preOpAnaesthesiaChartEntity.spontaneous}</dd>
          <dt>
            <span id="ventilatorMv">
              <Translate contentKey="tinyMedicRestApp.preOpAnaesthesiaChart.ventilatorMv">Ventilator Mv</Translate>
            </span>
          </dt>
          <dd>{preOpAnaesthesiaChartEntity.ventilatorMv}</dd>
          <dt>
            <span id="ventilatorRr">
              <Translate contentKey="tinyMedicRestApp.preOpAnaesthesiaChart.ventilatorRr">Ventilator Rr</Translate>
            </span>
          </dt>
          <dd>{preOpAnaesthesiaChartEntity.ventilatorRr}</dd>
          <dt>
            <span id="ventilatorTv">
              <Translate contentKey="tinyMedicRestApp.preOpAnaesthesiaChart.ventilatorTv">Ventilator Tv</Translate>
            </span>
          </dt>
          <dd>{preOpAnaesthesiaChartEntity.ventilatorTv}</dd>
          <dt>
            <span id="ventilatorIvRatio">
              <Translate contentKey="tinyMedicRestApp.preOpAnaesthesiaChart.ventilatorIvRatio">Ventilator Iv Ratio</Translate>
            </span>
          </dt>
          <dd>{preOpAnaesthesiaChartEntity.ventilatorIvRatio}</dd>
          <dt>
            <span id="patientPosition">
              <Translate contentKey="tinyMedicRestApp.preOpAnaesthesiaChart.patientPosition">Patient Position</Translate>
            </span>
          </dt>
          <dd>{preOpAnaesthesiaChartEntity.patientPosition}</dd>
          <dt>
            <span id="torniquetAppliedAt">
              <Translate contentKey="tinyMedicRestApp.preOpAnaesthesiaChart.torniquetAppliedAt">Torniquet Applied At</Translate>
            </span>
          </dt>
          <dd>{preOpAnaesthesiaChartEntity.torniquetAppliedAt}</dd>
          <dt>
            <span id="torniquetRemovedAt">
              <Translate contentKey="tinyMedicRestApp.preOpAnaesthesiaChart.torniquetRemovedAt">Torniquet Removed At</Translate>
            </span>
          </dt>
          <dd>{preOpAnaesthesiaChartEntity.torniquetRemovedAt}</dd>
          <dt>
            <span id="timeOfInduction">
              <Translate contentKey="tinyMedicRestApp.preOpAnaesthesiaChart.timeOfInduction">Time Of Induction</Translate>
            </span>
          </dt>
          <dd>{preOpAnaesthesiaChartEntity.timeOfInduction}</dd>
          <dt>
            <span id="timeOfIndcision">
              <Translate contentKey="tinyMedicRestApp.preOpAnaesthesiaChart.timeOfIndcision">Time Of Indcision</Translate>
            </span>
          </dt>
          <dd>{preOpAnaesthesiaChartEntity.timeOfIndcision}</dd>
          <dt>
            <span id="timeOfSurgeyCompletion">
              <Translate contentKey="tinyMedicRestApp.preOpAnaesthesiaChart.timeOfSurgeyCompletion">Time Of Surgey Completion</Translate>
            </span>
          </dt>
          <dd>{preOpAnaesthesiaChartEntity.timeOfSurgeyCompletion}</dd>
          <dt>
            <span id="timeOfExtubation">
              <Translate contentKey="tinyMedicRestApp.preOpAnaesthesiaChart.timeOfExtubation">Time Of Extubation</Translate>
            </span>
          </dt>
          <dd>{preOpAnaesthesiaChartEntity.timeOfExtubation}</dd>
          <dt>
            <span id="additionalNotes">
              <Translate contentKey="tinyMedicRestApp.preOpAnaesthesiaChart.additionalNotes">Additional Notes</Translate>
            </span>
          </dt>
          <dd>{preOpAnaesthesiaChartEntity.additionalNotes}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.preOpAnaesthesiaChart.active">Active</Translate>
            </span>
          </dt>
          <dd>{preOpAnaesthesiaChartEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.preOpAnaesthesiaChart.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{preOpAnaesthesiaChartEntity.cursor}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.preOpAnaesthesiaChart.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{preOpAnaesthesiaChartEntity.lastupdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.preOpAnaesthesiaChart.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{preOpAnaesthesiaChartEntity.microSec}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.preOpAnaesthesiaChart.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{preOpAnaesthesiaChartEntity.timestampentry}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.preOpAnaesthesiaChart.surgery">Surgery</Translate>
          </dt>
          <dd>{preOpAnaesthesiaChartEntity.surgery ? preOpAnaesthesiaChartEntity.surgery.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.preOpAnaesthesiaChart.anaesthesiologist">Anaesthesiologist</Translate>
          </dt>
          <dd>{preOpAnaesthesiaChartEntity.anaesthesiologist ? preOpAnaesthesiaChartEntity.anaesthesiologist.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.preOpAnaesthesiaChart.vitals">Vitals</Translate>
          </dt>
          <dd>{preOpAnaesthesiaChartEntity.vitals ? preOpAnaesthesiaChartEntity.vitals.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.preOpAnaesthesiaChart.nurse">Nurse</Translate>
          </dt>
          <dd>{preOpAnaesthesiaChartEntity.nurse ? preOpAnaesthesiaChartEntity.nurse.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/pre-op-anaesthesia-chart" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/pre-op-anaesthesia-chart/${preOpAnaesthesiaChartEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default PreOpAnaesthesiaChartDetail;
